import React, { useMemo } from "react";

import { Table } from "../../../../../Common/Table";

import { VehicleNameCell } from "./TableCells/FixedNameCell/VehicleNameCell";
import { VehicleVINCell } from "./TableCells/VehicleVINCell";
import { VehicleLastBookingCell } from "./TableCells/VehicleLastBookingCell";
import { VehicleColourBadge } from "../../../../../Common/VehicleColourBadge";
import { VehicleMenuCell } from "./TableCells/VehicleMenuCell";
import { LoadingIcon } from "../../../../../Common/Loading_Icon";

export const VehiclesList = ({ vehicles, loading, history, match, location, sortBy, sortOrder, updateSorting }) => {
	const addSortClasses = (sortTerm) =>
		sortBy === sortTerm
			? sortOrder === "asc" ? "fa-sort-up primary" : "fa-sort-down primary"
			: "fa-sort";

	const columns = useMemo(
		() => [
			{
				Header: () => (
					<div
						style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
						className={sortBy === 'vehicle' ? 'is-sorted' : 'th'}
						onClick={() => updateSorting('vehicle')}
					>
						<span>Vehicle</span>
						<i className={`sort-icon fas black-lightest ${addSortClasses('vehicle')}`}></i>
					</div>
				),
				accessor: 'displayName',
				sticky: 'left',
				width: 400,
				minWidth: 300,
				Cell: ({ row }) => <VehicleNameCell vehicle={row.original} {...{ history, match, location }} />
			},
			{
				// Header: 'VIN',
				Header: () => (
					<div
						style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
						className={sortBy === 'vin' ? 'is-sorted' : 'th'}
						onClick={() => updateSorting('vin')}
					>
						<span>VIN</span>
						<i className={`sort-icon fas black-lightest ${addSortClasses('vin')}`}></i>
					</div>
				),
				accessor: 'VIN',
				width: window.innerWidth > 1850 ? 260 : 210,
				minWidth: 200,
				Cell: ({ value }) => <VehicleVINCell VIN={value} />
			},
			{
				Header: 'Plate',
				accessor: 'licensePlate',
			},
			{
				Header: 'Mileage',
				accessor: 'odometer',
				Cell: ({ value = 0 }) => <>{new Intl.NumberFormat('en-CA').format(value)} KM</>
			},
			{
				Header: 'Utilization',
				accessor: 'utilization',
				Cell: ({ value = 0 }) => <>{parseFloat(value * 100).toFixed(0)}%</>
			},
			{
				Header: 'Bookings',
				accessor: 'totalBookings',
			},
			{
				Header: 'Last Booking',
				accessor: 'latestBooking.scheduledReturnedAt',
				width: 220,
				minWidth: 190,
				Cell: ({ value }) => <VehicleLastBookingCell lastBookingDate={value} />
			},
			{
				Header: 'Exterior Colour',
				accessor: 'exteriorColor',
				width: 220,
				minWidth: 190,
				Cell: ({ value }) => <VehicleColourBadge colourName={value} />
			},
			{
				Header: 'Interior Colour',
				accessor: 'interiorColor',
				width: 220,
				minWidth: 190,
				Cell: ({ value }) => <VehicleColourBadge colourName={value} />
			},
			{
				Header: '',
				accessor: 'menu',
				width: 100,
				Cell: ({ row }) => <VehicleMenuCell vehicle={row.original} {...{ history, match, location }} />
			},
		],
		[sortBy, sortOrder, vehicles]
	)

	const data = useMemo(() => vehicles, [vehicles]);

	return (
		<div className="vehicles-table">
			<Table columns={columns} data={data} fixedHeader />

			{loading && (
				<div className="vehicles-table-loading">
					<LoadingIcon />
				</div>
			)}
		</div>
	)
}
